<div class="fullscreen">

    <div class="row justify-content-center m-0 auth-box">
        <div class="col-sm-4 p-0">

            <mat-card class="p-0">
                <div class="d-flex justify-content-center">
                    <div class="logo-wrapper" (click)="changeServer = changeServer?changeServer + 1 :1">
                        <ng-container>
                            <img class="logo-img" src="../../images/mapsender.png">
                        </ng-container>
                    </div>
                </div>
                <div class="d-flex justify-content-center">
                    <ng-container *ngIf="!status">
                        <h3 class="text-center mt-4">{{ 'INIT.TITLE' | translate }}</h3>
                    </ng-container>
                    <ng-container *ngIf="status">
                        <h3 translate class="text-center mt-4 danger">{{ 'INIT.TITLE_ERR' | translate }}</h3>
                    </ng-container>
                </div>
                <mat-progress-bar *ngIf="curComponent.loading" mode="indeterminate"></mat-progress-bar>
                <mat-card-content class="p-4">
                    
                    <router-outlet (activate)="componentAdded($event)"></router-outlet>
                    
                </mat-card-content>

            </mat-card>
        </div>
    </div>

</div>
<div *ngIf="loading">
    <div class="loading">
        <mat-spinner color="accent"></mat-spinner>
    </div>
</div>
